import { render, staticRenderFns } from "./UiCheck.vue?vue&type=template&id=bd27a70e&scoped=true&"
import script from "./UiCheck.vue?vue&type=script&lang=js&"
export * from "./UiCheck.vue?vue&type=script&lang=js&"
import style0 from "./UiCheck.vue?vue&type=style&index=0&id=bd27a70e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd27a70e",
  null
  
)

export default component.exports